import { type ReactElement } from 'react'
import { Card, CardHeader, CardContent, Grid, Box, Breadcrumbs, IconButton } from '@mui/material'
import { H1, Body2White } from '@/components/typography'
import css from './styles.module.css'
import NavigateNextIcon from '@mui/icons-material/NavigateNext'
import HomeIcon from '@mui/icons-material/Home'
import useDesktop from '@/hooks/useDesktop'
import Link from 'next/link'
import { useRouter } from 'next/router'
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft'

const PageCard = ({
  title,
  children,
  headerBtn,
  backBtn,
}: {
  title: string
  children: ReactElement
  headerBtn?: ReactElement
  backBtn?: boolean
}): ReactElement => {
  const isDesktop = useDesktop()
  const router = useRouter()

  return (
    <Box className={css.container}>
      <Card sx={{ border: 'none', borderRadius: isDesktop ? '6px' : '0px' }}>
        {isDesktop && (
          <CardHeader
            sx={{ padding: '0px', paddingX: backBtn ? '16px' : '32px' }}
            title={
              <Grid container>
                {backBtn && (
                  <Grid item container xs={'auto'} alignContent="center">
                    <Link href={{ pathname: '/home', query: { wallet: router.query.wallet } }} passHref>
                      <IconButton>
                        <KeyboardArrowLeftIcon sx={{ color: '#22C55E' }} />
                      </IconButton>
                    </Link>
                  </Grid>
                )}
                <Grid item py={'16px'}>
                  <H1>{title}</H1>
                </Grid>
                {headerBtn && (
                  <Grid item container xs justifyContent="flex-end" p={'16px'}>
                    {headerBtn}
                  </Grid>
                )}
              </Grid>
            }
          />
        )}

        {!isDesktop && (
          <Breadcrumbs
            aria-label="breadcrumb"
            sx={{
              paddingX: '16px',
              paddingY: '8px',
              // borderBottom: '1px solid var(--Ebony-Clay-950, #2F354B)',
            }}
            separator={<NavigateNextIcon fontSize="small" />}
          >
            <Link href={{ pathname: '/home', query: { wallet: router.query.wallet } }} passHref>
              <HomeIcon
                sx={{
                  mr: 0.5,
                  color: 'var(--Ebony-Clay-500, #7C8AB4)',
                  display: 'flex',
                  alignItems: 'center',
                  fontSize: '18px',
                }}
              />
            </Link>
            <Body2White sx={{ color: 'var(--Ebony-Clay-500, #7C8AB4)' }}>{title}</Body2White>
          </Breadcrumbs>
        )}

        <CardContent className={css.cardContent} sx={{ paddingTop: '0px' }}>
          {children}
        </CardContent>
      </Card>
    </Box>
  )
}

export default PageCard
